/** @format */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AttainmentWithThesis, AttainmentWithThesisSearchRequest, SearchRequest } from 'common-typescript/types';
import * as _ from 'lodash-es';
import { Observable } from 'rxjs';
import { DowngradedService, ServiceDowngradeMappings, StaticMembers } from 'sis-common';

const CONFIG = {
    ENDPOINTS: {
        backend: '/ori/api/attainments/attainment-with-thesis',
    },
};

@StaticMembers<DowngradedService>()
@Injectable({ providedIn: 'root' })
export class AttainmentWithThesisService {
    constructor(private http: HttpClient) {}

    static downgrade: ServiceDowngradeMappings = {
        dependencies: [],
        moduleName: 'sis-components.service.attainmentWithThesisService',
        serviceName: 'attainmentWithThesisService',
    };

    private static toQueryParams(searchParams: Partial<AttainmentWithThesisSearchRequest>): { [key: string]: string | string[] } {
        if (_.isEmpty(searchParams)) {
            return {};
        }

        return _.omitBy(
            {
                courseUnitId: searchParams.courseUnitId,
                start: searchParams.start ? searchParams.start.toString() : null,
                limit: searchParams.limit ? searchParams.limit.toString() : null,
            },
            _.isEmpty,
        );
    }

    search(searchParams: AttainmentWithThesisSearchRequest): Observable<SearchRequest<AttainmentWithThesis>> {
        return this.http.get(`${CONFIG.ENDPOINTS.backend}/search`, {
            params: AttainmentWithThesisService.toQueryParams(searchParams),
        }) as Observable<SearchRequest<AttainmentWithThesis>>;
    }
}
